import { render, staticRenderFns } from "./SettingsNavigation.vue?vue&type=template&id=18207372&"
import script from "./SettingsNavigation.vue?vue&type=script&lang=js&"
export * from "./SettingsNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports